import React, { Component } from "react";
import { Link } from "react-router-dom";
// import RightMenu from '../../Elements/RightMenu/RightMenu';
//import HtmlToReactParser from 'html-to-react';
import "./index.css";
//import CalendarPicker from 'rc-calendar';
import RightIconMenu from "../RightIconMenu";
import $ from "jquery";
export default class View_type_2 extends Component {
	constructor(props) {
		super(props);
		//console.log("jury View_type_2: ", props);
		var data = Array.isArray(props.data) ? props.data[0] : props.data;
		this.state = {
			data: data,
			r_menu: data.right_menu ? data.right_menu : [],
			title: data.title ? data.title : "",
			tabs: data.tabs ? props.data.tabs : [],
			calendar: data.calendar ? data.calendar : null,
			content: data.content ? data.content : [],
			read_more: data.read_more ? data.read_more : [],
			list: data.list ? data.list : [],
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		//console.log(this.state);
	}




	createMarkup(item) {
		return { __html: item };
	}





	render() {
		var _this = this;
		var var1 = this.state.data.title ? this.state.data.title : "";
		let advancedSearch=null
		var calendar = this.state.calendar ? (
			<Link to={this.state.calendar.url}>
				<div className="vt2-calendar">
					<img className="vt2-calendar-img" src={this.state.calendar.img} />
					{this.state.calendar.text}
				</div>
			</Link>
		) : null;

		return (
			<div className="vt2">
				<div className="vt2 left col-xs-12 col-sm-8 col-md-8 col-lg-8">
					<div className="vt2 row">
						<div className="vt2-title">
							<div
								className="vt2-title-name artists-pageTitle"
								dangerouslySetInnerHTML={{ __html: var1 }}
							/>
							<div className="vt2-title-tabs">
								{this.state.tabs.map(function(object, i) {
									if (object.active === 1) {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<div className="vt2 tab-checked">
													<Link to={"/" + object.link}>{object.title}</Link>
												</div>
											</div>
										);
									} else {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<Link to={"/" + object.link}>{object.title}</Link>
											</div>
										);
									}
								})}
							</div>
						</div>
						<div className="vt2-content">
							<div
								dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
							/>
						</div>
						<div className="newWrapper">
							{this.state.data.list.map(function(object, i) {
								//console.log("tlo", object);

								if (object.cols == 3) {
									var color = "rgba(0,156,178,0.5)";

									if (
										object !== "undefined" &&
										object.hasOwnProperty("img") &&
										!object.hasOwnProperty("text")
									) {
										var img = object.img;
										var thumbnail = (
											<div
												style={{
													flex: 1,
													backgroundColor: color,
													padding: 10,
													color: "white",
													position: "absolute",
													left: 15,
													right: 15
												}}
											>
												{object.title}
											</div>
										);
										return (
											<div
												className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
												key={i}
											>
												<div>
													{thumbnail}
													<img src={img} className="vt2 list_image" />
												</div>
											</div>
										);
									} else if (object !== "undefined") {
										var button = null;
										var img = object.img;
										var thumbnail = (
											<div
												className="vt2 middle-thumbnailholder"
												style={{
													flex: 1,
													backgroundColor: color,
													padding: 10,
													color: "white"
												}}
											>
												{object.title}
											</div>
										);
										var img = (
											<div>
												<img src={img} />
											</div>
										);

										// if (typeof object.button !== "undefined") {
										// 	button = (
										// 		<div className="vt2 middle-addelem">
										// 			<Link
										// 				to={object.button.link}
										// 				className="vt2 more_button"
										// 			>
										// 				{" "}
										// 			</Link>
										// 		</div>
										// 	);
										// }

										if (i == 0) {
											return (
												<div
													className="vt2-col col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center"
													key={i}
												>
													<div className="vt2 row">
														<div
															onClick={() =>
																(window.location.href = `${object.url}`)
															}
															className="vt2 middle-postblock middle-postblock--box"
															style={{
																backgroundImage: `url(${object.img})`,
																height: "150px",
																cursor: "pointer"
															}}
														>
															{/* {img} */}
														</div>
														{object && (
															<div className="vt2-description">
																<Link to={`${object.url}`}>
																	<div
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.text
																		)}
																	/>
																</Link>
																{button}
															</div>
														)}
													</div>
												</div>
											);
										} else {
											return (
												<div
													className="vt2-col col-xs-12 col-sm-4 col-md-4 col-lg-4 text-center"
													key={i}
												>
													<div className="vt2 row">
														<div
															onClick={() =>
																(window.location.href = `${object.url}`)
															}
															className="vt2 middle-postblock middle-postblock--box"
															style={{
																height: "150px",
																cursor: "pointer",
																background: `url(${object.img})`
															}}
														>
															{/* {img} */}
														</div>
														{object && (
															<div className="vt2-description">
																<Link to={`${object.url}`}>
																	<div
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.text
																		)}
																	/>
																</Link>
																{button}
															</div>
														)}
													</div>
												</div>
											);
										}
									}
								} else {
									var color = "rgba(0,156,178,0.5)";

									if (
										object !== "undefined" &&
										object.hasOwnProperty("img") &&
										!object.hasOwnProperty("text")
									) {
										var img = object.img;
										var thumbnail = (
											<div
												style={{
													flex: 1,
													backgroundColor: color,
													padding: 10,
													color: "white",
													position: "absolute",
													left: 15,
													right: 15
												}}
											>
												{object.title}
											</div>
										);
										return (
											<div
												className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
												key={i}
											>
												<div className="test123">
													{thumbnail}
													<img src={img} className="vt2 list_image" />
												</div>
											</div>
										);
									} else if (object !== "undefined") {
										var button = null;
										var img = object.img;
										var thumbnail = (
											<div
												className="vt2 middle-thumbnailholder"
												style={{
													flex: 1,
													backgroundColor: color,
													padding: 10,
													color: "white"
												}}
											>
												{object.title}
											</div>
										);
										var img = (
											<div>
												<img src={img} />
											</div>
										);

										if (typeof object.button !== "undefined") {
											button = (
												<div className="vt2 middle-addelem">
													<Link
														to={object.button.link}
														className="vt2 more_button"
													>
														{" "}
													</Link>
												</div>
											);
										}

										if (i == 0) {
											return (
												<div
													className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
													key={i}
												>
													<div className="vt2 middle-postblock">
														{img}
														<div
															dangerouslySetInnerHTML={_this.createMarkup(
																object.text
															)}
														/>
														{button}
													</div>
												</div>
											);
										} else {
											return (
												<div
													className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
													key={i}
												>
													<div className="vt2 middle-postblock">
														{img}
														<div
															dangerouslySetInnerHTML={_this.createMarkup(
																object.text
															)}
														/>
														{button}
													</div>
												</div>
											);
										}
									}
								}
							})}
						</div>
					</div>
				</div>
				<div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{calendar && (
						<div className="vt2 RightMenu">
							<ul className="vt2 right_menu_items">
								{this.state.r_menu.map(function(object, i) {
									var var4 = object.url ? object.url : "";
									var var5 = object.name ? object.name : "";
									//console.log("RightMenu", object);
									return (
										<li className="vt2 left-menuItem" key={i}>
											<Link className="vt2 left-menuUnit" to={"/" + var4}>
												{var5}
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					)}
					{advancedSearch && (
						<div className="vt2 RightMenu">
							<div className="vt2 right_menu_items right_menu_items--search">
								<input className="vt2 search_input" type="text" />
								<p className="vt2 search_input__description">
									szukanie zaawansowane
								</p>
							</div>
						</div>
					)}

					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
				}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_2/index.js